import { request } from '../@utils'
import { requestFile } from '../@utils'
import store from '../@store'
const CommonService = {
  getBrandList: async params => {
    const res = await request.post('/common/brand/list', { data: params })
    return res
  },
  getCategoryTree: async (params = {}) => {
    const res = await request.post('/common/category/tree', { data: params })
    return res
  },
  getArea: async params => {
    const res = await request.get('/common/address/getAllArea', { params: params })
    return res
  },
  getPackageUnitList: async params => {
    const res = await request.post('/common/packageUnit/list', { data: params })
    return res
  },
  getFileTaskByCondition: async params => {
    const res = await request.post('/common/fileTask/getFileTaskByCondition', { data: params })
    return res
  },
  downloadFileById: async (id) => {
    const res = await requestFile.get(
      `/common/fileTask/downloadFileById/${id}`,
      { responseType: "blob" }
    );
    return res;
  },
  getFileTemplate: async (params) => {
    const res = await requestFile.get(
      "/common/file-template/download-template",
      { params: params, responseType: "blob" }
    );
    return res;
  },
  addFileTask: async params => {
    const res = await request.post('/common/fileTask/addFileTask', { data: params })
    return res
  },
  uploadPictureFile: async params => {
    const res = await request.post('/common/uploadPictureFile', {
      data: params,
      headers: {
        'Content-Type':
          'multipart/form-data; boundary=----WebKitFormBoundaryAWMfW6MLBDIyYgrB'
      }
    })
    return res
  },
  getValidSupplierList: async (params = {pageIndex: 1, pageSize: 99999}) => {
    const res = await request.post('common/supplier/getValidSupplierList', {data: params})
    store.dispatch({
      type: 'common/suppliers',
      payload: res
    })
  },
  getStoreList: async () => {
    const res = await request.post('common/store/list')
    store.dispatch({
      payload: res,
      type: 'store/list'
    })
    return res
  },
  getStoreListAll: async () => {
    const res = await request.post('common/store/list/all')
    store.dispatch({
      payload: res,
      type: 'store/list/all'
    })
    return res
  },
  queryMerchantProductList: async (params) => {
    const res = await request.post("/common/merchant/query",{ data: params });
    return res;
  }
}
export default CommonService
